import { render, staticRenderFns } from "./AddTaxLossModal.vue?vue&type=template&id=8617f792"
import script from "./AddTaxLossModal.vue?vue&type=script&lang=js"
export * from "./AddTaxLossModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8617f792')) {
      api.createRecord('8617f792', component.options)
    } else {
      api.reload('8617f792', component.options)
    }
    module.hot.accept("./AddTaxLossModal.vue?vue&type=template&id=8617f792", function () {
      api.rerender('8617f792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/AddTaxLossModal.vue"
export default component.exports